
import { Suspense } from "react";
import ReactDOM from "react-dom/client";

//redux
import store from "./redux/store";
import { Provider } from "react-redux";

//css
import "./index.css";
import "mdb-react-ui-kit/dist/css/mdb.min.css";

//main app
import App from "./App";
import httpService from "./services/http.service";

import "./i18n/i18n";

httpService.initializeInterceptors(store.dispatch);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <Suspense fallback={null}>
      <App />
    </Suspense>
  </Provider>,
);
